export interface NarrowedDay {
  date: string
  lessons: string[]
}

export interface SneakPeekSelectionValue {
  teacher_id: string
  date_from: string
  date_to: string
  selected_dates?: string[]
  narrowed_days?: NarrowedDay[]
}

export function selectionValue(
  teacherId: string,
  dateFrom: string,
  dateTo: string,
  selectedDates: string[],
  narrowedDays: NarrowedDay[] = [],
): SneakPeekSelectionValue {
  return {
    teacher_id: teacherId,
    date_from: dateFrom,
    date_to: dateTo,
    ...(selectedDates.length ? { selected_dates: selectedDates } : {}),
    ...(narrowedDays.length ? { narrowed_days: narrowedDays } : {}),
  }
}

export function splitLessonIdentity(entryId: string, start?: string | null, split = false) {
  if (!split) return entryId
  return `${entryId}|${(start || '').slice(0, 5)}`
}

export function clipToken(entryId: string, start?: string | null, split = false) {
  return splitLessonIdentity(entryId, start, split)
}

export function clipAllowed(token: string, entryId: string, start?: string | null) {
  return token === splitLessonIdentity(entryId, start, false)
    || token === splitLessonIdentity(entryId, start, true)
}

export function narrowingKey(days: NarrowedDay[] | null | undefined) {
  return (days ?? [])
    .map((day) => `${day.date}:${[...day.lessons].sort().join('|')}`)
    .sort()
    .join(',')
}

export function deriveNarrowing(
  dates: string[],
  removed: string[],
  requestableByDate: Record<string, string[]>,
  selectedByDate: Record<string, string[]>,
): NarrowedDay[] {
  const rows: NarrowedDay[] = []
  for (const date of dates) {
    if (removed.includes(date)) continue
    const requestable = requestableByDate[date] ?? []
    if (!requestable.length) continue
    const chosen = (selectedByDate[date] ?? []).filter((id) => requestable.includes(id))
    const complete = chosen.length === requestable.length
      && requestable.every((id) => chosen.includes(id))
    if (complete) continue
    rows.push({ date, lessons: chosen })
  }
  return rows
}
